interface Props<T extends string> {
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
}

/** One-of-n buttons, styled like the City | Location switch on the charts. */
export const SegmentedToggle = <T extends string>({
  value,
  options,
  onChange,
}: Props<T>) => (
  <div className="inline-flex rounded border border-gray-border overflow-hidden">
    {options.map((option, index) => (
      <button
        key={option.value}
        type="button"
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
        className={`px-3 py-1 text-xs sm:text-sm font-satoshi font-medium whitespace-nowrap ${
          index > 0 ? "border-l border-gray-border" : ""
        } ${
          value === option.value
            ? "bg-droppie-oranje text-white"
            : "bg-white text-gray-text"
        }`}
      >
        {option.label}
      </button>
    ))}
  </div>
);
